import { graphMetrics } from "../analysis/graph";
import {
  meanLinkDistances,
  meanSpeed,
  radiusOfGyration,
} from "../analysis/metrics";
import type { SimView } from "../core/simView";

function fmt(n: number, d = 2): string {
  if (!Number.isFinite(n)) return "—";
  return n.toFixed(d);
}

export class MetricsPanel {
  private readonly pre: HTMLElement;
  private readonly sel: HTMLElement;
  private speeds = new Float64Array(0);

  constructor(host: HTMLElement) {
    host.innerHTML = "";
    const h = document.createElement("h2");
    h.textContent = "Insights";
    this.pre = document.createElement("p");
    this.pre.className = "metrics-strip";
    this.pre.id = "metrics-strip";
    this.sel = document.createElement("p");
    this.sel.className = "selection-hud hidden";
    this.sel.id = "selection-hud";
    host.append(h, this.pre, this.sel);
  }

  update(view: SimView, selectedIndex: number): void {
    const { n, dim } = view;
    if (this.speeds.length !== n) this.speeds = new Float64Array(n);
    view.writeSpeeds(this.speeds);

    const g = graphMetrics(view.friends);
    const links = meanLinkDistances(
      view.positions,
      dim,
      view.friends,
      view.enemies,
    );
    const rg = radiusOfGyration(view.positions, dim, n);
    const vbar = meanSpeed(this.speeds, n);

    this.pre.textContent =
      `⟨speed⟩ ${fmt(vbar, 4)} · Rg ${fmt(rg, 3)}\n` +
      `⟨dist friend⟩ ${fmt(links.meanFriend, 3)} · ⟨dist enemy⟩ ${fmt(links.meanEnemy, 3)}\n` +
      `cycles ${g.nCycles} · on-cycle ${g.nodesOnCycle}/${n} · max cycle ${g.maxCycleLen}\n` +
      `tails ${g.nTails} · chain depth mean ${fmt(g.meanTailDepth)} · max ${g.maxChainDepth}`;

    if (selectedIndex >= 0 && selectedIndex < n) {
      const f = view.friends[selectedIndex]!;
      const e = view.enemies[selectedIndex]!;
      const sp = this.speeds[selectedIndex]!;
      this.sel.classList.remove("hidden");
      this.sel.textContent = `selected #${selectedIndex} → friend #${f} (blue) · enemy #${e} (amber) · speed ${fmt(sp, 4)}`;
    } else {
      this.sel.classList.add("hidden");
      this.sel.textContent = "";
    }
  }
}
